/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  var cfg = window.deskStoolPopup && window.deskStoolPopup.config;
  if (!cfg || !cfg.enabled || !cfg.offerProductId) return;

  var $popup = $('#stool-popup');
  if (!$popup.length) return;

  var sitOneIds = (cfg.sitOneIds || []).map(Number);
  var sitProIds = (cfg.sitProIds || []).map(Number);
  var stoolIds = (cfg.stoolIds || []).map(Number);
  var chairIds = sitOneIds.concat(sitProIds);
  var colorOptionNames = (cfg.colorOptionNames || []).map(function (s) { return s.toLowerCase(); });

  function cartHasAny(cartItems, ids) {
    if (!ids.length) return false;
    for (var i = 0; i < cartItems.length; i++) {
      if (ids.indexOf(Number(cartItems[i].product_id)) !== -1) return true;
    }
    return false;
  }

  function justAddedChair(cartItems, addedVariantIds) {
    if (!addedVariantIds || !addedVariantIds.length) return false;
    var addedSet = addedVariantIds.map(Number);
    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      if (addedSet.indexOf(Number(item.variant_id)) === -1) continue;
      var productId = Number(item.product_id);
      if (chairIds.indexOf(productId) !== -1) return true;
    }
    return false;
  }

  function isEligible(cart, addedVariantIds) {
    var items = (cart && cart.items) || [];
    var hasStool = cartHasAny(items, stoolIds);
    return justAddedChair(items, addedVariantIds) && !hasStool;
  }

  function getChairColor(cartItems, addedVariantIds) {
    var addedSet = addedVariantIds.map(Number);
    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      if (addedSet.indexOf(Number(item.variant_id)) === -1) continue;
      var productId = Number(item.product_id);
      if (chairIds.indexOf(productId) === -1) continue;
      var opts = item.options_with_values || [];
      for (var j = 0; j < opts.length; j++) {
        if (colorOptionNames.indexOf(opts[j].name.toLowerCase()) !== -1) {
          return opts[j].value;
        }
      }
    }
    return null;
  }

  var chairWasInCartLastCheck = null;

  function cartHasChair(cartItems) {
    return cartHasAny(cartItems, chairIds);
  }

  function syncChairTracking() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        chairWasInCartLastCheck = cartHasChair((cart && cart.items) || []);
      })
      .catch(function () {});
  }

  document.addEventListener('cart:rendered', syncChairTracking);
  syncChairTracking();

  var releaseFocus = null;

  function openPopup() {
    $popup.addClass('is-open').attr('aria-hidden', 'false');
    $('body').addClass('modal-open');
    if (window.lenis && typeof window.lenis.stop === 'function') window.lenis.stop();

    if (!releaseFocus && window.DeskA11y && $popup[0]) releaseFocus = window.DeskA11y.trapFocus($popup[0]);
  }

  function closePopup() {
    $popup.removeClass('is-open').attr('aria-hidden', 'true');
    $('body').removeClass('modal-open');
    if (window.lenis && typeof window.lenis.start === 'function') window.lenis.start();
    if (releaseFocus) {
      releaseFocus();
      releaseFocus = null;
    }
  }

  function goToCart() {
    closePopup();
    window.location.href = window.Shopify.routes.root + 'cart';
  }

  function maybeShowAfterAdd(event) {
    var addedVariantIds = (event && event.detail && event.detail.variantIds) || [];
    if (!addedVariantIds.length) return;
    var hadChairBefore = chairWasInCartLastCheck === true;
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        chairWasInCartLastCheck = cartHasChair(items);

        if (hadChairBefore) return; // a chair was already in the cart — never re-arm
        if (!isEligible(cart, addedVariantIds)) return;

        var chairColor = getChairColor(items, addedVariantIds);
        setTimeout(function () {
          selectSwatchByColor(chairColor);
          openPopup();
        }, 400);
      })
      .catch(function () {});
  }

  document.addEventListener('desk:cart-item-added', maybeShowAfterAdd);

  $popup.find('.stool-popup__scroller').on('click', function (e) {
   if (e.target === this) closePopup();
 });
  $popup.find('[data-stool-popup-close]').on('click', closePopup);
  $popup.find('[data-stool-popup-skip]').on('click', goToCart);
 document.addEventListener('keydown', function (e) {
   if ((e.key === 'Escape' || e.keyCode === 27) && $popup.hasClass('is-open')) {
     e.stopPropagation();
     e.stopImmediatePropagation();
     closePopup();
   }
 }, true);
  var $swatches = $popup.find('[data-stool-swatches] .stool-popup__swatch');
  var $addBtn = $popup.find('[data-stool-add-btn]');
  var $colorLabel = $popup.find('[data-selected-color-label]');
  var $currentPrice = $popup.find('[data-current-price]');
  var $comparePrice = $popup.find('[data-compare-price]');
  var $priceBadge = $popup.find('[data-price-badge]');
  var $imageDesktop = $popup.find('[data-stool-popup-image="desktop"]');
  var $imageMobile = $popup.find('[data-stool-popup-image="mobile"]');
  var $topBadges = $popup.find('.stool-popup__badge-desktop, .stool-popup__badge-mobile');
  var $topBadgeTexts = $topBadges.find('span');

  $swatches.on('click', function () {
    if ($(this).is(':disabled')) return;
    var $swatch = $(this);

    $swatches.removeClass('is-active');
    $swatch.addClass('is-active');

    var variantId = $swatch.attr('data-variant-id');
    $addBtn.attr('data-variant-id', variantId);
    $colorLabel.text($swatch.attr('data-color-label') || '');
    $currentPrice.text($swatch.attr('data-price') || '');
    $comparePrice.text($swatch.attr('data-compare') || '');
    $priceBadge.text($swatch.attr('data-badge') || '');

    var hasDiscount = $swatch.attr('data-has-discount') === 'true';
    $topBadges.toggleClass('is-discount-hidden', !hasDiscount);
    if (hasDiscount) {
      $topBadgeTexts.html($swatch.attr('data-badge-copy') || '');
    }

    var imageDesktop = $swatch.attr('data-image');
    if (imageDesktop && $imageDesktop.length) {
      $imageDesktop.attr('src', imageDesktop);
      $imageDesktop.attr('srcset', imageDesktop);
    }

    var imageMobile = $swatch.attr('data-image-mobile') || imageDesktop;
    if (imageMobile && $imageMobile.length) {
      $imageMobile.attr('src', imageMobile);
      $imageMobile.attr('srcset', imageMobile);
    }
  });
  function selectSwatchByColor(colorValue) {
    if (!colorValue) return;
    var $match = $swatches.filter(function () {
      return ($(this).attr('data-color-label') || '').toLowerCase() === colorValue.toLowerCase();
    }).first();
    if ($match.length && !$match.is(':disabled')) {
      $match.trigger('click');
    }
  }

  function applyDiscountCode() {
    if (!cfg.discountCode) return Promise.resolve();

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: cfg.discountCode }),
    }).catch(function (e) {
      console.error('Stool popup discount apply error:', e);
    });
  }

  $addBtn.on('click', function () {
    var $btn = $(this);
    if ($btn.hasClass('loading')) return;
    var variantId = parseInt($btn.attr('data-variant-id'), 10);
    if (!variantId) return;
    $btn.addClass('loading');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(applyDiscountCode)
      .then(function () {
        window.refreshCartDrawer?.();
        closePopup();
      })
      .catch(function (e) {
        console.error('Stool popup add error:', e);
      })
      .finally(function () {
        $btn.removeClass('loading');
      });
  });
});